import React from 'react';

export default function OpeningStockPDF({ open, onClose, rows }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 print-modal">
      <div className="bg-white rounded-lg shadow-lg max-w-3xl w-full p-6 relative print:w-full print:max-w-full">
        <button
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-2xl no-print"
          onClick={onClose}
        >
          &times;
        </button>
        <h2 className="text-2xl font-bold mb-4 text-center">Opening Stock</h2>
        <table className="min-w-full border border-gray-300 mb-4">
          <thead>
            <tr className="bg-gray-200">
              <th className="px-3 py-2 border">SNo</th>
              <th className="px-3 py-2 border">Prod Id</th>
              <th className="px-3 py-2 border">Prod Name</th>
              <th className="px-3 py-2 border">UOM</th>
              <th className="px-3 py-2 border">Stock Qty</th>
              <th className="px-3 py-2 border">Stock Rate</th>
              <th className="px-3 py-2 border">Stock Value</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={row.id || idx}>
                <td className="px-3 py-2 border">{idx + 1}</td>
                <td className="px-3 py-2 border">{row.prodId}</td>
                <td className="px-3 py-2 border">{row.prodName}</td>
                <td className="px-3 py-2 border">{row.uom}</td>
                <td className="px-3 py-2 border">{row.stockQty}</td>
                <td className="px-3 py-2 border">{row.stockRate}</td>
                <td className="px-3 py-2 border">{row.stockValue}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-center">
          <button
            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 no-print"
            onClick={() => window.print()}
          >
            Print
          </button>
        </div>
      </div>
    </div>
  );
} 